import Keycloak from 'keycloak-js'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { api_gateway } from '../../conexoes/api'
import { imagemPerfil } from '../../redux/actions/index'
import { logout } from '../../services/auth'
import decryptJWT from '../../utils/decryptJWT'
import utilsLocalStorage from '../../utils/localStorage'

export default function Logout(props) {
  const cdClienteErp = localStorage.getItem('clientePrimario')
  const despacho = useDispatch()

  useEffect(() => {
    async function Logout() {
      ClearKeycloac()
      await api_gateway
        .post('/m1/servicos/dados/logout', {
          id: decryptJWT('id')
        })
        .then(function () {
          logout()
          if (cdClienteErp == 2455) {
            window.location.reload()
          }
          props.history.push('/login')
        })
        .catch(function () {
          logout()
          props.history.push('/login')
        })
    }
    async function ClearKeycloac() {
      const keycloak = Keycloak(`${process.env.PUBLIC_URL}/keycloak.json`)
      keycloak.init().then(() => {
        keycloak.logout()
      })
    }
    despacho(imagemPerfil(''))
    ClearKeycloac()
    Logout()
    utilsLocalStorage.removeLocalStorageSms()
  }, [])

  return <Redirect to={{ pathname: '/login' }} />
}
